// extracted by mini-css-extract-plugin
module.exports = {"orange":"#e38826","darkCyan":"#006970","veryDarkCyan":"#004241","card":"css-99f34cc","card__head":"css-d017eb8","card__body":"css-cea49e5","card__foot":"css-ca353b1"};